var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "rightContBan" } },
    [
      _c(
        "div",
        {
          staticClass: "right-cont-banner",
          attrs: { id: "shareRightContBan" }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.iePromptShow,
                  expression: "iePromptShow"
                }
              ],
              staticClass: "browser-prompt",
              staticStyle: { "background-color": "#eceff6" },
              style: { width: _vm.getPromptWidth() }
            },
            [
              _c(
                "span",
                [
                  _c("font", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("language.rightTopBanner.browserPrompt")
                      )
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "icon-util top-close top-close-button",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.iePromptShow = false
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "personal-center" }, [
            _c("div", { staticClass: "center-left" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "clickoutside",
                      rawName: "v-clickoutside",
                      value: _vm.personalMenuClose,
                      expression: "personalMenuClose"
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isLogin,
                      expression: "isLogin"
                    }
                  ],
                  staticClass: "icon-util personal personal-left",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.personalMenuOpen()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.personalMenuShow,
                          expression: "personalMenuShow"
                        }
                      ],
                      ref: "personalMenu",
                      staticClass: "personal-menu"
                    },
                    [
                      _c("div", { staticClass: "personal-account" }, [
                        _c(
                          "div",
                          {
                            staticClass: "personal-account-item",
                            attrs: { title: _vm.email }
                          },
                          [_vm._v(_vm._s(_vm.email))]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "personal-info",
                          on: {
                            mouseenter: function($event) {
                              return _vm.changePass()
                            },
                            mouseleave: function($event) {
                              _vm.selectMenuIndex = -1
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "icon-util properties personal-icon-position"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "personal-item" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.rightTopBanner.settings"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "icon-util pull-triangle personal-moremenu-position"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.selectMenuIndex == 0,
                                  expression: "selectMenuIndex==0"
                                }
                              ],
                              ref: "setMenuOne",
                              staticClass: "personal-setting-menu"
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.judgeTourist(),
                                      expression: "!judgeTourist()"
                                    }
                                  ],
                                  staticClass: "personal-info",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.changeNameOpen()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      ref: "changeName",
                                      staticClass: "setting-position"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "language.rightTopBanner.changeName"
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.judgeTourist() &&
                                        !_vm.judgeThird(),
                                      expression:
                                        "!judgeTourist()&&!judgeThird()"
                                    }
                                  ],
                                  staticClass: "personal-info",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.changePassOpen()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      ref: "changePassWord",
                                      staticClass: "setting-position"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "language.rightTopBanner.changePassword"
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.judgeTourist(),
                                      expression: "judgeTourist()"
                                    }
                                  ],
                                  staticClass: "personal-info",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.bindEmailOpen()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "setting-position" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.rightTopBanner.bindEmail"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "personal-info",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.deleteAccountOpen()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "setting-position" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.rightTopBanner.deleteAccount"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "personal-info",
                          on: {
                            mouseenter: function($event) {
                              _vm.selectMenuIndex = 1
                            },
                            mouseleave: function($event) {
                              _vm.selectMenuIndex = -1
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "icon-util multi-language personal-icon-position"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "personal-item" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.rightTopBanner.language"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "icon-util pull-triangle personal-moremenu-position"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.selectMenuIndex == 1,
                                  expression: "selectMenuIndex==1"
                                }
                              ],
                              staticClass: "personal-setting-menu"
                            },
                            _vm._l(_vm.languageArr, function(item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "personal-info",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.checkLanguage(index)
                                    }
                                  }
                                },
                                [
                                  _c("div", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.checkLanguageIndex == index,
                                        expression: "checkLanguageIndex==index"
                                      }
                                    ],
                                    staticClass:
                                      "icon-util language-check language-check-position"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "language-position" },
                                    [_vm._v(_vm._s(item))]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "personal-info",
                          on: {
                            mouseenter: function($event) {
                              return _vm.menuHelpShow()
                            },
                            mouseleave: function($event) {
                              _vm.selectMenuIndex = -1
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "icon-util help personal-icon-position"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "personal-item " }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.rightTopBanner.help"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "icon-util pull-triangle personal-moremenu-position"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.selectMenuIndex == 2,
                                  expression: "selectMenuIndex==2"
                                }
                              ],
                              ref: "setMenuTwo",
                              staticClass: "personal-setting-menu"
                            },
                            _vm._l(_vm.helpArr, function(item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "personal-info",
                                  on: {
                                    click: function($event) {
                                      return _vm.openHelpLink(index)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      ref: "detail",
                                      refInFor: true,
                                      staticClass: "setting-position"
                                    },
                                    [_vm._v(_vm._s(item))]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "personal-info",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.logout()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "icon-util logout personal-icon-position",
                            staticStyle: { margin: "0 1px 0 5px!important" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "personal-item" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.rightTopBanner.logout"))
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "center-right" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isLogin,
                      expression: "isLogin"
                    }
                  ],
                  staticClass: "center-right-position"
                },
                [
                  _vm.user && _vm.user.payType == "Lifetime"
                    ? _c(
                        "button",
                        {
                          staticClass: "upgrade-button",
                          on: {
                            click: function($event) {
                              return _vm.switchToPay()
                            }
                          }
                        },
                        [
                          _vm.payBtn.img
                            ? _c("img", { attrs: { src: _vm.payBtn.img } })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "payTxt" }, [
                            _vm._v(_vm._s(_vm.payBtn.txt))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.user && _vm.user.payType != "Lifetime"
                    ? _c(
                        "button",
                        {
                          staticClass: "upgrade-button",
                          on: {
                            click: function($event) {
                              return _vm.switchToPay()
                            }
                          }
                        },
                        [
                          _vm.timerExpired
                            ? _c("div", [
                                _c("div", {
                                  staticClass: "right-top-icon icon starImg"
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "payTxt" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("language.valentineSale.payTxt")
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "active-button" })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.timerExpired
                            ? _c("div", [
                                _vm.payBtn.img
                                  ? _c("div", {
                                      staticClass: "right-top-icon icon",
                                      class: _vm.payBtn.img
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "payTxt" }, [
                                  _vm._v(_vm._s(_vm.payBtn.txt))
                                ])
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "right-content" }, [
                    _c("div", { staticClass: "progress-bar" }, [
                      _c("div", {
                        class:
                          _vm.btnColor == "grey" ? "" : "inner-progress-bar",
                        style: {
                          width:
                            (_vm.usedTraffic / _vm.totalTraffic) * 100 + "%"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.totalTraffic != -1
                      ? _c("div", { staticClass: "drive-space" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("language.rightTopBanner.traffic")
                              ) +
                              ":" +
                              _vm._s(
                                _vm._f("formatByteForBanner")(_vm.usedTraffic)
                              ) +
                              "/" +
                              _vm._s(
                                _vm._f("formatByteForBanner")(_vm.totalTraffic)
                              ) +
                              "\n                    "
                          )
                        ])
                      : _c("div", { staticClass: "drive-space" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("language.rightTopBanner.traffic")
                              ) +
                              ":" +
                              _vm._s(
                                _vm._f("formatByteForBanner")(_vm.usedTraffic)
                              ) +
                              "/" +
                              _vm._s(
                                _vm.$t("language.rightTopBanner.unlimited")
                              ) +
                              "\n                    "
                          )
                        ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isLogin,
                      expression: "!isLogin"
                    }
                  ],
                  staticClass: "center-right-position",
                  staticStyle: { "border-left": "0" }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "ga",
                          rawName: "v-ga",
                          value: {
                            eventAction: "click",
                            eventCategory: "/sign.html",
                            eventLabel: "/share-top-right"
                          },
                          expression:
                            "{eventAction:'click',eventCategory:'/sign.html',eventLabel:'/share-top-right'}"
                        }
                      ],
                      staticClass: "center-right-position-sign",
                      staticStyle: { "padding-left": "25px" },
                      on: {
                        click: function($event) {
                          return _vm.openToSignUp()
                        }
                      }
                    },
                    [
                      _c("button", { staticClass: "sign-up-btn" }, [
                        _vm._v(_vm._s(_vm.$t("language.login.signUp")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "center-right-position-sign",
                      on: {
                        click: function($event) {
                          return _vm.signInDialogShow()
                        }
                      }
                    },
                    [
                      _c("button", { staticClass: "sign-in-btn" }, [
                        _vm._v(_vm._s(_vm.$t("language.login.signIn")))
                      ])
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("notificationsDialog", { ref: "notificationsDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78dc15fd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78dc15fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/share_right_top_banner.vue
// module id = null
// module chunks = 